import { getPaymentDetails, setTimer } from './partials/utils';

setTimer(1200, true, 'timerFirst', 'proPageOffer');
setTimer(1200, true, 'timerSecond', 'proPageOffer');

document.getElementById('month').setAttribute('href', getPaymentDetails(countryCode, platform, 'month', 'pro-page', useAlternateGateway).url);
document.getElementById('sixmonths').setAttribute('href', getPaymentDetails(countryCode, platform, 'sixmonths', 'pro-page', useAlternateGateway).url);
document.getElementById('year').setAttribute('href', getPaymentDetails(countryCode, platform, 'year', 'pro-page', useAlternateGateway).url);

document.getElementById('monthPrice').innerHTML = getPaymentDetails(countryCode, platform, 'month', 'instructions', useAlternateGateway).price;
document.getElementById('sixmonthsPrice').innerHTML = getPaymentDetails(countryCode, platform, 'sixmonths', 'instructions', useAlternateGateway).price;
document.getElementById('yearPrice').innerHTML = getPaymentDetails(countryCode, platform, 'year', 'instructions', useAlternateGateway).price;

const $agreeCheckbox = document.getElementById('agree-checkbox');
const $tryProButton = document.getElementById('try-pro-action');

$tryProButton.setAttribute('href', getPaymentDetails(countryCode, platform, 'month', 'pro-page', useAlternateGateway).url);

if ($agreeCheckbox) {
  $agreeCheckbox.addEventListener('change', (event) => {
    $tryProButton.classList.toggle('disabled', !event.currentTarget.checked);
  });
}
